import { useEffect, useState } from "react"

const DEBOUNCE_TIMEOUT = 100

export function useDebounce<T>(value: T, delay?: number) {
  const [cacheValue, setCacheValue] = useState<T>(value)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCacheValue(value)
    }, delay ?? DEBOUNCE_TIMEOUT)

    return () => clearTimeout(timeout)
  }, [value])

  return cacheValue
}
